import { CoverageDisplayPipe } from 'app/shared/pipes/coverage-display.pipe';

const coverageDisplayPipe = new CoverageDisplayPipe();

export interface PlanDescriptionSource {
  planDescription?: string;
  // Required: the pipe branches on the type and divides by the months, so a caller that omits
  // either gets NaN. coverageMiles is safe to omit — a missing value just drops the suffix.
  coverageDisplayTypeID: number;
  coverageMonths: number;
  coverageMiles?: number;
  isLimitedLifetimeWarrantyPlan?: boolean;
}

// A lifetime plan has no term to state, so it renders the name alone.
export function descriptionDisplayFor(item: PlanDescriptionSource): string {
  const planDescription = item.planDescription?.trim();

  if (item.isLimitedLifetimeWarrantyPlan === true) return planDescription ?? '';

  const coverage = coverageDisplayPipe.transform(item.coverageDisplayTypeID, item.coverageMonths, item.coverageMiles);

  return planDescription ? `${planDescription} - ${coverage}` : coverage;
}
